const tutorial = {
  getTutorials: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ tutorials {
          Tutorial_Id
          Title
          Description
          URL
        }
      }`
      })
      .then(r => {
        return r.data.tutorials;
      });
  },

  createTutorial: async function(tutorialToCreate) {
    var query = `
    mutation($title: String!, $description: String, $url: String!) {
      CreateTutorial(title: $title, description: $description, url: $url) {
        Tutorial_Id
      }
    }`;
    var variables = {
      title: tutorialToCreate.Title.trim(),
      description: tutorialToCreate.Description ? tutorialToCreate.Description.trim() : "",
      url: tutorialToCreate.URL.trim()
    };

    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      tutorialToCreate.Tutorial_Id = r.data.CreateTutorial.Tutorial_Id;
      return tutorialToCreate;
    });
  },
  updateTutorial: async function(tutorialToUpdate) {
    var query = `
    mutation($tutorialId: Int!, $title: String!, $description: String, $url: String!) {
      UpdateTutorial(tutorialId: $tutorialId, title: $title, description: $description, url: $url) {
        Tutorial_Id
      }
    }`;
    var variables = {
      tutorialId: parseInt(tutorialToUpdate.Tutorial_Id),
      title: tutorialToUpdate.Title.trim(),
      description: tutorialToUpdate.Description ? tutorialToUpdate.Description.trim() : tutorialToUpdate.Description,
      url: tutorialToUpdate.URL.trim()
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return tutorialToUpdate;
    });
  },
  deleteTutorial: async function(tutorialToDelete) {
    var query = `
    mutation($tutorialId: Int!) {
      DeleteTutorial(tutorialId: $tutorialId) 
    }`;
    var variables = {
      tutorialId: parseInt(tutorialToDelete.Tutorial_Id)
    };

    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return tutorialToDelete;
    });
  }
};

export { tutorial };
